module.exports = __webpack_public_path__ + "img/inovacao.3faa3fb6.svg";